import React from 'react'
import './RecentBlogsPlugin.scss'
import { useSelector } from 'react-redux'

function RecentBlogsPlugin({ listOfRecentBlogs }) {

  const blogPageTheme = useSelector(state => state.GetBlogPageThemeReducer)
  const theme = blogPageTheme?.blogTheme

  return (
    <>
      <div className={theme?.recentBlogLayout == 'vertical' ? 'recent-blog-container col-3' : 'recent-blog-container'} style={theme?.recentBlogLayout == 'vertical' ? { display: 'block', color: `${theme?.titleFontColor}` } : { color: `${theme?.titleFontColor}` }}>
        {listOfRecentBlogs?.map((oneRecentBlog, index) => {

          return (
            <a href={oneRecentBlog.pageUrl ? oneRecentBlog.pageUrl : "#"} className="teaser-card" >
              <div className="teaser-img" style={{ flexBasis: '45%' }}>
                {oneRecentBlog?.blogImage ? <img alt=""
                  src={oneRecentBlog.blogImage}
                  data-img={oneRecentBlog.blogImage} ></img>
                  : ""}
              </div>
              <div className="teaser-content" >
                <div className="teaser-content-tag" >
                  <i className="bi bi-person-circle mx-2"></i>
                  {oneRecentBlog?.userName}
                </div>
                <div className="teaser-content-tag" >
                  <i className="bi bi-clock mx-2"></i>
                  {oneRecentBlog?.publishDate}
                </div>

                <div className="teaser-content-tag" style={{ fontWeight: 'bold' }}>{oneRecentBlog?.attributes?.blogCategory}</div>
                <div className="teaser-content-title" style={{ fontSize: '20px' }}>{oneRecentBlog?.attributes?.containerTitle}
                </div>
                <div className="teaser-content-description" style={{ fontSize: '16px', height: '100px', overflow: 'hidden' }}>{oneRecentBlog?.attributes?.teaser}</div>
                <div className="teaser-content-bottom" style={{ textAlign: 'right', fontSize: '18px' }}>
                  <span className="article-link"> <span className="article-link__text">Read More</span> <span className="article-link__icon">&gt;</span> </span>
                </div>
              </div>
            </a>
          )
        })}

      </div>
    </>
  )
}

export default RecentBlogsPlugin
